import { SET_RESPONSE, RESET_RESPONSE } from '../constants/actionTypes';

export const setResponse = (payload) => ({ type: SET_RESPONSE, payload });
export const resetResponse = (payload) => ({ type: RESET_RESPONSE, payload });
